<template>
  <div>
    <transition name="fade">
      <NavbarMobile/>
    </transition>
    <transition name="fade">
      <slot/>
    </transition>
  </div>
</template>

<script>
import NavbarMobile from './shared/NavbarMobile.vue';

export default {
  name: 'MobileBaseLayout',
  components: { NavbarMobile },
};

</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
